import classNames from 'classnames';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { TNotification } from 'utils/types';

dayjs.extend(relativeTime);

export interface NotificationItemProps {
  notification: TNotification;
  className?: string;
  type: 'dropdownItem' | 'pageItem';
  onClick?: () => void;
}

const NotificationItem = ({
  notification,
  className,
  type,
  onClick
}: NotificationItemProps) => {
  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        onClick
          ? event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      className={classNames(
        className,
        'py-3 notification-card position-relative',
        {
          unread: !notification.isRead,
          'px-4 px-lg-6': type === 'pageItem',
          'px-2 px-sm-3': type === 'dropdownItem'
        },
        { 'cursor-pointer': onClick }
      )}
    >
      <div
        className={classNames('flex-1', {
          'me-sm-3': type === 'dropdownItem',
          'mt-2 me-2': type === 'pageItem'
        })}
      >
        <h4 className="fs-9 text-body-emphasis fw-bold mb-1">
          {notification.title}
        </h4>
        <p className="fs-9 text-body-highlight mb-1 fw-normal notification-body">
          {notification.body}
        </p>
        <p className="text-body-quaternary text-opactity-75 fw-bold fs-10 mb-0">
          {dayjs(notification.createdOn).fromNow()}
        </p>
      </div>
    </div>
  );
};

export default NotificationItem;
